import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, ClipboardListIcon, RocketIcon, CheckCircleIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    icon: ShoppingCartIcon,
    title: 'Click "Get Started" & Pay',
    description: '$297/month for ONE platform (Yelp, Facebook, or Instagram). No setup fee. You can cancel anytime.',
    details: "Takes 2 minutes. You'll get an email confirmation immediately."
  }, {
    number: '2',
    icon: ClipboardListIcon,
    title: 'Fill Out a Quick Form',
    description: 'Tell us: Your business name, which ONE platform you want (Yelp/Facebook/Instagram), your hours, and how you want customers to book.',
    details: "Takes 5 minutes. We'll email you the form right after you pay."
  }, {
    number: '3',
    icon: RocketIcon,
    title: 'We Build Everything (2-3 Days)',
    description: 'We connect to your platform, set up your calendar, write your AI responses, and test everything.',
    details: "You don't do anything. We'll email you when it's ready to go live."
  }, {
    number: '4',
    icon: CheckCircleIcon,
    title: 'You Approve & Go Live',
    description: 'We send you a test message so you can see how it works. You say "looks good" and we flip it on.',
    details: 'From that moment, every message gets answered and jobs get booked automatically.'
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-151">
      <div className="max-w-6xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-153">
          <h2 className="text-4xl md:text-5xl font-bold text-[var(--jet-black)] mb-4" data-id="element-154">
            What Happens After You Buy
          </h2>
          <p className="text-xl text-[var(--graphite-gray)] max-w-2xl mx-auto" data-id="element-155">
            From payment to fully automated in 4 simple steps.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto space-y-8" data-id="element-156">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex gap-6 items-start bg-[var(--white-smoke)] p-6 rounded-xl" data-id="element-157">
              {/* Number badge */}
              <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 bg-[var(--viridia-green)] text-white rounded-full text-xl font-bold" data-id="element-158">
                {step.number}
              </div>

              <div className="flex-grow" data-id="element-159">
                {/* Title */}
                <h3 className="text-2xl font-bold text-[var(--jet-black)] mb-2" data-id="element-160">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-lg text-[var(--graphite-gray)] mb-2" data-id="element-161">
                  {step.description}
                </p>

                {/* Details */}
                <p className="text-sm text-[var(--graphite-gray)] italic" data-id="element-162">
                  {step.details}
                </p>
              </div>

              {/* Icon */}
              <step.icon className="flex-shrink-0 w-10 h-10 text-[var(--deep-teal)]" data-id="element-163" />
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="mt-12 text-center" data-id="element-164">
          <div className="inline-block bg-green-50 border-2 border-[var(--viridia-green)] rounded-lg p-6" data-id="element-165">
            <p className="text-lg font-semibold text-[var(--jet-black)] mb-2" data-id="element-166">
              ⚡ Most contractors are live and booking jobs within 72 hours
            </p>
            <p className="text-sm text-[var(--graphite-gray)]" data-id="element-167">
              We handle everything. You just show up to the jobs.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}